export const UnionIcon = (props: any) => {
    return (
        <svg width="10" height="9" viewBox="0 0 10 9" fill="#9B9B9B" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M3.08977 8.01562C3.08977 8.22305 3.25617 8.39062 3.46242 8.39062H6.53743C6.74368 8.39062 6.91008 8.22305 6.91008 8.01562V5.71875H3.08977V8.01562ZM9.3136 0H0.686253C0.399143 0 0.219847 0.312891 0.363987 0.5625L2.95735 4.96875H7.04485L9.63821 0.5625C9.78 0.312891 9.60071 0 9.3136 0Z"/>
        </svg>
    )
}